<template>
  <div class="coupon-list-popup">
    <transition :name="tranName" appear @after-leave="hidePopup">
      <div
        v-if="visible"
        class="coupon-list-popup-content"
        :class="{ 'to-bottom': hasLoadPaytype }"
      >
        <div class="coupon-list-popup-title">
          {{ letter.couponSelect }}
        </div>
        <div class="coupon-list-popup-type-wrap">
          <div
            class="coupon-list-popup-type flex-center"
            :class="{ active: listType === 'enable' }"
            @click="updateListType('enable')"
          >
            {{ letter.couponCanUse }} ({{ enableCouponList.length }})
            <transition name="slide-left">
              <div
                v-show="listType === 'enable'"
                class="underline-wrap flex-center"
              >
                <div class="underline"></div>
              </div>
            </transition>
          </div>
          <div
            class="coupon-list-popup-type flex-center"
            :class="{ active: listType === 'disable' }"
            @click="updateListType('disable')"
          >
            {{ letter.couponCanNotUse }} ({{ invalidCouponTotal }})
            <transition name="slide-right">
              <div
                v-show="listType === 'disable'"
                class="underline-wrap flex-center"
              >
                <div class="underline"></div>
              </div>
            </transition>
          </div>
        </div>
        <div class="coupon-list-popup-type-tip">
          <p>{{ letter.couponUseTip }}</p>
          <p v-if="popupType != 'paytype'">
            {{ letter.voucherCouponTipGuide }}
          </p>
        </div>
        <div class="coupon-list-popup-content-scroll">
          <template v-if="listType === 'enable'">
            <template v-if="enableCouponList.length">
              <coupon-item
                v-for="item in enableCouponList"
                :key="item.COUPON_ID"
                :info="item"
                :active="chooseCouponId === item.COUPON_ID"
                @chooseCoupon="chooseCoupon"
                :invalid="popupType === 'game'"
              ></coupon-item>
            </template>
            <template v-else>
              <coupon-item :isEmpty="true"></coupon-item>
            </template>
          </template>
          <template v-else>
            <template v-if="invalidCouponTotal > 0">
              <coupon-item
                v-for="item in disableCouponList"
                :key="item.COUPON_ID"
                :info="item"
                :invalid="true"
              ></coupon-item>
              <coupon-item
                v-for="item in expireCouponList"
                :key="item.COUPON_ID"
                :info="item"
                :invalid="true"
              ></coupon-item>
            </template>
            <template v-else>
              <coupon-item :isEmpty="true" :invalid="true"></coupon-item>
            </template>
          </template>
        </div>
        <div class="coupon-list-popup-btn" v-show="popupType === 'paytype'">
          <Button class="confirm-btn" @click="confirmCoupon"
            >{{ letter.v3ConfirmUse }}
          </Button>
        </div>
        <p class="coupon-list-popup-rule" @click="jumpRulePage" v-if="showRule">
          {{ letter.v3LookUpCouponRule }}
        </p>
        <Icon
          class="coupon-list-popup-close flex-center"
          name="close"
          @click="beforeHidePopup"
        />
      </div>
    </transition>
    <transition name="fade" appear>
      <div class="popup-shadow" v-if="visible" @click="beforeHidePopup"></div>
    </transition>
  </div>
</template>

<script type="text/javascript">
import coupon from '@mixins/officialTopupNew/coupon';
import style from '@mixins/officialTopupNew/style';
import CouponItem from '@components/officialTopupNew/coupon/CouponItem.vue';
import { mapState, mapGetters } from 'vuex';
import bridge from '@utiles/officialStore/bridge';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  name: 'couponListPopup',
  mixins: [coupon, style],
  props: [
    'enableCouponList',
    'disableCouponList',
    'expireCouponList',
    'popupType'
  ],
  data() {
    return {
      chooseCouponId: '',
      listType: 'enable',
      visible: true
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      letter: state => state.letter,
      paytype: state => state.paytype,
      curLocation: state => state.curLocation,
      curTax: state => state.curTax,
      showCartList: state => state.cart.showCartList,
      showCurrency: state => state.showCurrency,
      paytypeActiveCouponId: state => state.coupon.paytypeActiveCouponId,
      gameActiveCouponId: state => state.coupon.gameActiveCouponId,
      hasLoadPaytype: state => state.hasLoadPaytype,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['gameInfoConfig']),
    invalidCouponTotal() {
      return this.disableCouponList.length + this.expireCouponList.length;
    },
    letter() {
      return this.$store.state.letter;
    },
    showRule() {
      return this.gameInfoConfig?.showCouponRule;
    }
  },
  methods: {
    updateListType(type) {
      this.listType = type;
    },
    hidePopup() {
      this.$emit('closeCouponPopup');
    },
    beforeHidePopup() {
      this.visible = false;
    },
    chooseCoupon(couponId) {
      // 游戏优惠券不可选择
      if (this.popupType == 'game') return;
      if (this.chooseCouponId === couponId) {
        this.chooseCouponId = '';
      } else {
        this.chooseCouponId = couponId;
      }
    },
    confirmCoupon() {
      if (this.popupType == 'game') {
        // this.updateGameActiveCouponId(this.chooseCouponId);
      }
      if (this.popupType == 'paytype') {
        this.updatePaytypeActiveCouponId(this.chooseCouponId);
      }
      this.beforeHidePopup();
    },
    jumpRulePage() {
      const link = getGlobalGetGotoLink({
        link: `${window.location.origin}/platform/officialStore.html?gameId=${this.gameId}&language=${this.lang}&fromV3=1#/vip_score`
      });
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openBrowser', {
          url: link,
          loginDir: 1,
          appendParams: 1
        });
      } else {
        window.open(link, '_blank');
      }
    }
  },
  mounted() {
    this.chooseCouponId =
      this.popupType === 'game'
        ? this.gameActiveCouponId
        : this.paytypeActiveCouponId;
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  // 层级高过选择角色弹窗，权益中心调过来查看优惠券时
  z-index: 1002;

  .popup-shadow {
    z-index: 1;
  }

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  &-title {
    @include g-popup-title();
    flex-shrink: 0;
    border-radius: 20px 20px 0 0;
    padding: 40px 36px;
    box-sizing: border-box;
    width: 100%;
    color: #333333;
    font-size: 28px;
  }
  &-content {
    z-index: 2;
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    // padding: 20px 7px;
    padding: 0;
    width: 100%;
    background: $backgroundColor;
    border-radius: 20px 20px 0 0;
    max-height: 70vh;
    &-scroll {
      flex: 1;
      height: 708px;
      overflow-y: scroll;
      position: relative;
      margin: 0 16px;
      margin-top: 20px;
      padding: 0 20px;
    }
  }
  &-type-wrap {
    display: flex;
    justify-content: center;
    line-height: 1.2;
    margin-bottom: 15px;
    align-items: center;
  }
  &-type {
    position: relative;
    font-size: 24px;
    color: #666666;
    width: 50%;
    padding-bottom: 16px;
    cursor: pointer;
    &:hover {
      font-weight: bold;
    }
    &.active {
      font-weight: bold;
      color: #333333;
    }
    &-tip {
      font-size: 22px;
      border-radius: 6px;
      box-sizing: border-box;
      padding: 10px 20px;
      text-align: center;
      line-height: 1.2;
      background-color: #ececec;
      margin: 0 36px;
    }
    .underline-wrap {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 6px;
    }
    .underline {
      width: 80px;
      height: 6px;
      background-color: $themeColor;
    }
  }
  &-close {
    display: none;
    position: absolute;
  }
  &-close {
    display: none;
    position: absolute;
  }
  &-btn {
    flex-shrink: 0;
    margin: 30px 40px;
    height: 59px;
    box-sizing: border-box;
    background-color: $themeColor;
    border-radius: 9px;
    .confirm-btn {
      color: #f6f6f6;
      width: 100%;
      height: 100%;
      &.disabled {
        pointer-events: none;
        background-color: #999999;
      }
    }
  }
  &-rule {
    font-size: 24px;
    color: #333333;
    text-align: center;
    margin: 30px 0;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: $themeColor;
    }
  }
}

#ssr-page.landscape {
  .coupon-list-popup {
    &-title {
      display: none;
    }
    &-content {
      display: block;
      position: absolute;
      width: $landscapePopupWidth;
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      padding: 0;
      transform: translate(-50%, -50%);
      border-radius: 20px;
      height: fit-content;
      max-height: fit-content;
      &-scroll {
        overflow-y: scroll;
        margin: 0 18px;
        margin-top: 22px;
        height: 403px;
        padding: 3px 18px 18px;
      }
    }
    &-title {
      height: 61px;
      line-height: 61px;
      font-size: 22px;
    }
    &-type-wrap {
      @include g-popup-title();
      // margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 38px 0 0;
      border-radius: 20px 20px 0 0;
    }
    &-type {
      font-size: 18px;
      color: #333;
      width: 50%;
      text-align: center;
      &-line {
        height: 27px;
        vertical-align: middle;
        border-top: 0;
      }
      &-tip {
        font-size: 16px;
        color: #333;
        padding: 14px 18px;
        text-align: center;
      }
    }
    &-close {
      display: block;
      right: 42px;
      top: 38px;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    &-rule {
      font-size: 18px;
      margin: 20px 0;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .coupon-list-popup-content-scroll {
    height: 391px;
  }
}

/* iPad纵向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .coupon-list-popup-content-scroll {
    height: 391px;
  }
}
</style>
